export class Preloader {
	constructor() {
		this.preloader = document.querySelector('.preloader');
		this.autoHideTimer = null;
		this.isHiding = false;
		this.init();
	}

	init() {
		if (!this.preloader) return;

		// Скрываем прелоадер по умолчанию (будет показан после SiteLoader)
		this.preloader.style.display = 'none';

		// Можно установить фоновое изображение карты здесь
		// this.setBackgroundImage();
	}

	setBackgroundImage(imageUrl) {
		const background = this.preloader.querySelector('.preloader__background');
		if (background && imageUrl) {
			background.style.backgroundImage = `url(${imageUrl})`;
		}
	}

	hide() {
		if (this.isHiding || !this.preloader) return;
		
		this.isHiding = true;
		
		// Очищаем таймер, если он был установлен
		if (this.autoHideTimer) {
			clearTimeout(this.autoHideTimer);
			this.autoHideTimer = null;
		}

		// Удаляем обработчик клика
		if (this.clickHandler) {
			this.preloader.removeEventListener('click', this.clickHandler);
			this.clickHandler = null;
		}

		this.preloader.classList.add('preloader--hidden');
		setTimeout(() => {
			if (this.preloader) {
				this.preloader.remove();
			}
		}, 500);
	}

	show() {
		if (!this.preloader || this.isHiding) return;
		
		this.preloader.style.display = 'block';
		this.preloader.classList.remove('preloader--hidden');

		// Обработчик клика на любую область прелоадера
		this.clickHandler = () => {
			this.hide();
		};
		this.preloader.addEventListener('click', this.clickHandler);

		// Автоматическое скрытие через 5 секунд
		this.autoHideTimer = setTimeout(() => {
			this.hide();
		}, 5000);
	}
}

